export default {
  count: 0,
  isLogged: false,
  layout: 'app-layout',
  user: null,
  notification: '',
  refreshRequest: null,
  auth: {},
  testUser: false,
  beamsUser: null,
  version: null
}
